<template>
  <div id="Error">
    <Navbar/>
    <img alt="Vue logo" src="../assets/logo.png">
    <div >
      <img src="https://media.tenor.com/images/b276eb1262c2ae17a7d94929051d7a9d/tenor.gif" width="500" height="500" frameBorder="0" class="giphy-embed" allowFullScreen/><p></p>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
export default {
  name: 'ErrorPage',
  components:{
     Navbar,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Error{
  text-align: center;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
